import React, { useEffect, useRef, useState } from 'react'
import TopNavigation from "./../Components/Widgets/TopNavigation";
import { BrowserMultiFormatReader } from "@zxing/browser";
import { toast } from 'react-toastify';
import mevError from './../assets/mevent-error.png';
import mevCheck from './../assets/mevent-check.png';
import Loading from '../Components/Others/Loading';
import { useSelector } from 'react-redux';
import axios from 'axios';
import * as CONSTANTS from "./../CONSTANTS";
import { Link, useNavigate } from 'react-router-dom';
import mevSuccess from './../assets/success-load.png';
import QRScanSuccess from '../Components/Diaologues/QRScanSuccess';

function QRCodeScan() {

  const {user}                                            = useSelector((state) => state.auth);
  
  const [scanBtnShow, setScanBtnShow]                     = useState(true);
  const [scanning, setScanning]                           = useState(true);
  const [loading, setLoading]                             = useState(false);
  const [responseData, setResponseData]                   = useState(null);

  const [titleDialogue, setTitleDialogue]                 = useState("");
  const [urlImage, setUrlImage]                           = useState();

  const videoRef                                          = useRef(null);
  
  const startScan = async () => {
   
    setScanBtnShow(false)
    setScanning(true);
    setResponseData(null);
    
    const codeReader = new BrowserMultiFormatReader();
    
    try {

      const videoElement = videoRef.current;
    
      const result = await codeReader.decodeOnceFromVideoDevice(undefined, videoElement);
      const scannedText = result.text;
      let sponsorCode = "";

      // Check if the scanned text is a URL or just a raw 6-character code
      if (scannedText.includes('?code=')) {
          // Use URLSearchParams to cleanly extract the code
          const urlParams = new URLSearchParams(scannedText.split('?')[1]);
          sponsorCode = urlParams.get('code');
      } else if (scannedText.length === 6) {
          // Fallback for old QR codes that only contain the 6-digit code
          sponsorCode = scannedText;
      } else if (scannedText.length === 8) {
          // Fallback for old QR codes that only contain the 6-digit code
          sponsorCode = scannedText;
      }

        if (sponsorCode) {
            stopScan();
            
            // Stop the camera
            if (videoElement.srcObject) {
                videoElement.srcObject.getTracks().forEach(track => track.stop());
                videoElement.srcObject = null;
            }   

            // Pass the extracted code to your handler
            handleScannedData(sponsorCode);
        } else {
            toast.error("Invalid QR Code format.");
        }
      
    } catch (err) {
      console.log("QR scanning error:");
      console.log(err);
      toast.error("QR scanning failed. Try again.");
    }    
  };

  const handleScannedData = async (data) => {

    if (!/^(\w{6}|\w{8})$/.test(data.trim())) {
        toast.error("Invalid QR code! Must be 6 or 8 characters.");
        setResponseData({ status: "error" });
        return;
    }

    try {

      console.log(data.length)
        
      setLoading(true);

      if(data.length === 6){
          console.log("Let us marvel at the sponsor");
          ////////////////////////////////////////////
            const voting = {
                "userid" : user._id,
                "votingCode" : data
              }

              const response = await axios.post(CONSTANTS.API_URL +"votes/creation", voting, {
                      headers: {
                          token: "Bearer "+ user.accessToken
                      }
                  });
              
                if(response.status === 201){
                  setTitleDialogue("Your scan was succesfull.");
                  setUrlImage(mevSuccess);
                }else {
                  setTitleDialogue("We had a slight issue, please try again later.");
                  //toast.warning("We had a slight issue, please try again later.");
                  setUrlImage(mevError);
                }

              setResponseData({ status: "success", data: response.data });

          ////////////////////////////////////////////
      }else if(data.length === 8){
       
            const votingObject = {
                "userid" : user._id,
                "votingCode" : data
              }
      
            const response = await axios.post(CONSTANTS.API_URL +"votes/creation/scavenger/v1/", votingObject, {
                    headers: {
                        token: "Bearer "+ user.accessToken
                    }
                });

                
          if(response.status === 201){
                  setTitleDialogue("Your scan was succesfull.");
                  setUrlImage(mevSuccess);
                }else {
                  setTitleDialogue("We had a slight issue, please try again later.");
                  //toast.warning("We had a slight issue, please try again later.");
                  setUrlImage(mevError);
                }

              setResponseData({ status: "success", data: response.data });

      }
      setLoading(false);
    } catch (err) {
      if(err.status === 401){
        //toast.error(err.response.data);
        setTitleDialogue(err.response.data);
      }else if(err.status === 409){
        //toast.error(err.response.data);
        setTitleDialogue(err.response.data);
      }else {
        toast.error("Something went wrong, please try again later.")
      }
      setUrlImage(mevError);
      setResponseData({ status: "error" });
    } finally {
      setLoading(false);
    }
  };

  const stopScan = async () => {
    setScanBtnShow(true)
    setScanning(false);
    setResponseData(null);
  }

  const HandleRescan = () => {
      window.location.reload(true);
  }

  return (
    <div>
        <div className="top-navbar">
            <TopNavigation title={"QR Scanning"} />
        </div>
        <div className="layer-block">
           <div className="layer-content">
               
              <div className="pace-scan mgbot20">
                  {
                    scanBtnShow ? (
                        <button className="btn btn-mevent" onClick={startScan}>
                          SCAN
                        </button>
                      ) : 
                        (
                          <button className="btn btn-mevent" onClick={HandleRescan}>
                            STOP SCANNING
                          </button>
                        )
                  }
              </div>
              
              {
                scanning && (
                    <div className="scanning-area">
                      <video ref={videoRef} style={{ width: "100%" }} />
                    </div>
                  )                 
              }
              
              {loading && <Loading />}           

              {
                responseData && (
                  <QRScanSuccess 
                    title={titleDialogue}
                    urlString={urlImage}
                   />
                  )
                }
           </div>
        </div>
    </div>
  )
}
//Create a qr code scanner
//If a six character string is decoded from the qr code
//Then hide the scanner
//show the <div class="loading"></div> while you make post request. 
//Once the data returns hide the loading div and show the response div with complete image
//if the qr code returns anything except for a six digit number then toast invalid code and
//show the response div with error image

export default QRCodeScan